export default function VerticalDivider({height = '20'}: { height?: string }) {
  return (
    <svg
      width='2'
      height={height}
      viewBox={`0 0 2 ${height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='mx-4'
    >
      <path d="M1 0V420" stroke="#292929"/>
    </svg>
  );
}